import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { GalleryFolder } from "./GalleryFolder";
import "./styles";

const token = document.getElementsByName("csrf-token")[0].content;
const defaultFetchHeader = {
  "X-CSRF-Token": token,
  "Content-Type": "application/x-www-form-urlencoded",
};

const convertGalleryFolders = (folders) => {
  return JSON.stringify(
    folders.map((b) => ({
      id: b.id,
      order: b.order,
    }))
  );
};

const fetchGalleryFolders = (callback) => {
  return () => {
    axios
      .request({
        url: "/admin/gallery_folders.json",
        method: "GET",
        headers: defaultFetchHeader,
      })
      .then((resp) => resp.data)
      .then((json) => callback(json))
      .catch((err) => console.log(err));
  };
};

const updateGalleryFolderPosition = (galleryFolder) => {
  const formData = new FormData();
  formData.append("folders_orders", convertGalleryFolders(galleryFolder));
  axios({
    method: "put",
    url: "/update-folders-order",
    headers: defaultFetchHeader,
    data: formData,
  })
    .then(() => {
      location.replace(location.href);
    })
    .catch(() => {
      location.replace(location.href);
    });
};

const Drag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-grip-vertical"
    viewBox="0 0 16 16"
  >
    <path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
  </svg>
);

const FolderTitleWithDragIcon = ({ title }) => (
  <span style={{ display: "flex" }}>
    <Drag />
    <span>{title}</span>
  </span>
);

function GalleryFolderOrder({ folders: oriFolders }) {
  const [folders, setFolders] = useState([...oriFolders]);

  const moveFolder = useCallback(
    (dragIndex, hoverIndex) => {
      const newFolder = folders.map((folder, index) => {
        if (index == dragIndex) return { ...folder, order: hoverIndex };
        if (index >= hoverIndex && index <= dragIndex)
          return { ...folder, order: index + 1 };
        if (index <= hoverIndex && index >= dragIndex) {
          return { ...folder, order: index - 1 };
        } else return folder;
      });

      const dragFolder = newFolder[dragIndex];

      newFolder.splice(dragIndex, 1);
      newFolder.splice(hoverIndex, 0, dragFolder);

      setFolders(newFolder);
    },
    [folders]
  );

  const renderFolder = (folder, index) => {
    return (
      <div key={folder.id}>
        <GalleryFolder
          index={index}
          id={folder.id}
          title={<FolderTitleWithDragIcon title={folder.title} id={index} />}
          moveFolder={moveFolder}
        />
        <div style={{ visibility: "hidden" }}>
          <input type="hidden" value={folder.id} />
          <input type="hidden" value={index} />
        </div>
      </div>
    );
  };

  if (folders.length === 0) return "No folder found in this folder.";

  return (
    <>
      <div className="renderFileContainer">
        {folders.map((folder, i) => renderFolder(folder, i))}
      </div>
      <div className="fileOrderButton">
        <button onClick={() => updateGalleryFolderPosition(folders)}>
          Update File Order
        </button>
      </div>
    </>
  );
}

export default function GalleryFolderOrderContainer() {
  const [folders, setFolders] = useState(null);
  useEffect(fetchGalleryFolders(setFolders), []);
  return (
    <DndProvider backend={HTML5Backend}>
      {folders && <GalleryFolderOrder folders={folders} />}
    </DndProvider>
  );
}
